import React, { useContext } from 'react';
import { CSSTransition } from 'react-transition-group';

import { Context as NavigationContext } from '@swf/components/StarsWizard/components/Navigation/Navigation';
import type { TransitionProps } from '@swf/core/types/Wizard';
import { Event } from '@swf/core/types/Wizard';

import {
  ltrEnter,
  ltrEnterActive,
  ltrExit,
  ltrExitActive,
  ltrExitDone,
  rtlEnter,
  rtlEnterActive,
  rtlExit,
  rtlExitActive,
  rtlExitDone,
  transitionContainer,
  transitionDuration
} from './Transition.scss';

export const rtl = {
  enter: rtlEnter,
  enterActive: rtlEnterActive,
  exit: rtlExit,
  exitActive: rtlExitActive,
  exitDone: rtlExitDone
};
export const ltr = {
  enter: ltrEnter,
  enterActive: ltrEnterActive,
  exit: ltrExit,
  exitActive: ltrExitActive,
  exitDone: ltrExitDone
};

export const duration = parseFloat(transitionDuration) * 1000;

const Transition: React.FC<React.PropsWithChildren<TransitionProps>> = ({
  in: mount,
  children
}) => {
  const { trigger, next } = useContext(NavigationContext);
  const nodeRef = React.useRef(null);

  if (trigger) {
    const direction = trigger === Event.NEXT || (trigger === Event.JUMP && next) ? rtl : ltr;
    return (
      <CSSTransition
        nodeRef={nodeRef}
        in={mount}
        timeout={duration}
        classNames={direction}
        unmountOnExit
      >
        {trigger === Event.JUMP && next ? (
          children
        ) : (
          <div ref={nodeRef} className={transitionContainer}>
            {children}
          </div>
        )}
      </CSSTransition>
    );
  }

  return mount ? <>{children}</> : null;
};

export default Transition;
